var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineLikeTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 16.11c-.46 0-1.13-.14-1.52-.53l-1.54-1.19.92-1.19 1.61 1.25c.12.09.34.15.53.15h1.98c.3 0 .66-.26.73-.52l1.26-3.85c.03-.08.06-.19.01-.27-.04-.06-.15-.1-.28-.1h-2.08c-.37 0-.72-.16-.97-.44-.24-.28-.35-.66-.3-1.04l.26-1.67a.295.295 0 0 0-.17-.32c-.09-.03-.24.02-.28.07l-2.13 3.17-1.25-.84 2.13-3.17c.42-.63 1.31-.92 2.03-.65.81.27 1.33 1.17 1.15 2.01l-.21 1.37h1.82c.63 0 1.18.27 1.51.74.32.46.39 1.05.19 1.62l-1.24 3.78c-.23.89-1.19 1.62-2.18 1.62h-1.98z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04 15.54c-1.56 0-1.79-1.09-1.79-1.74V8.71c0-.65.23-1.74 1.79-1.74h.52c1.56 0 1.79 1.09 1.79 1.74v5.09c0 .65-.23 1.74-1.79 1.74h-.52zm0-1.5h.52c.16 0 .25-.02.28-.03 0-.02.01-.08.01-.21V8.71c0-.13-.01-.2-.02-.22-.02 0-.1-.01-.27-.01h-.52c-.16 0-.25.02-.28.03 0 .02-.01.08-.01.21v5.09c0 .13.01.2.02.23 0-.007.003-.01.01-.01.03 0 .11.01.26.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.06 21.95-1.71-1.69c-.43-.42-.99-.65-1.59-.65H6c-2.07 0-3.75-1.67-3.75-3.72V4.98c0-2.05 1.68-3.72 3.75-3.72h12c2.07 0 3.75 1.67 3.75 3.72v10.91c0 2.05-1.68 3.72-3.75 3.72h-.76c-.6 0-1.17.23-1.59.65l-1.71 1.69a2.75 2.75 0 0 1-3.88 0zM3.75 4.97v10.91c0 1.23 1.01 2.22 2.25 2.22h.76c1 0 1.94.39 2.65 1.09l1.71 1.69c.49.48 1.28.48 1.77 0l1.71-1.69c.71-.7 1.65-1.09 2.65-1.09H18c1.24 0 2.25-1 2.25-2.22V4.97c0-1.23-1.01-2.22-2.25-2.22H6c-1.24 0-2.25 1-2.25 2.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineLikeTag);
export default __webpack_public_path__ + "static/media/vuesax-outline-like-tag.2362b29b8e41c4baa84433a2cb05e39b.svg";
export { ForwardRef as ReactComponent };